import { defaultGrid } from "@helpers/datagrid";
import defaultReducer from "./defaultReducer";

export default defaultReducer("COLLECTION_BREAKDOWN_MODAL", {
  comments: [],
  loading: false,
  open: false,
  detailGrid: defaultGrid.grid,
  detailGridInterim: defaultGrid.grid,
  meterGrid: defaultGrid.grid,
  collectionPeriod: defaultGrid.grid,
  interimCollections: defaultGrid.grid,
  varianceHistory: defaultGrid.grid,
  transactionsGrid: defaultGrid.grid,
  eventsGrid: defaultGrid.grid,
  transactionsSummaryGrid: defaultGrid.grid,
  siteText: "Rimini Test lab A, Chester",
  weekText: "10 - Aug 1st - Aug 9th",
  egmText: "[54] - Lucky Dip, Rimini",
  showEventsGrid: false,
  showMetersGrid: true,
  showTicketsGrid: true,
  ticketsGrid: defaultGrid.grid,
  showMetersGridInterim: true,
  optionShowExport: false,
  optionShowVariance: false,
  optionShowVarianceHistory: false,
  onRefresh: () => {},
});
